var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"limitador"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.pesquisar}},[_c('span',{staticClass:"me-1"},[_vm._v("("+_vm._s(_vm.campo.qtd)+")")]),_vm._v(" "+_vm._s(_vm.campo.nome))])])}
var staticRenderFns = []

export { render, staticRenderFns }